import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

const ConstruirPdfFormatoRetorno = (datos) => {
    const cabezaFamilia = datos.cabezaFamilia;
    const desplazamiento = datos.desplazamiento;
    const numeropersonasResult = datos.numeropersonasResult;
    const retorno = datos.retorno;
    const ubicacion = datos.ubicacion;
    const grupoFamiliar = datos.grupoFamiliar;
    const redesApoyo = datos.redesApoyo;
    const motivosRetorno = datos.motivosRetorno
    const voluntariedadRetorno = datos.voluntariedadRetorno;
    const miembrosAtencionPsicosocial = datos.miembrosAtencionPsicosocial;
    const tipoexplotacion = datos.tipoexplotacion;
    const tipoEspecie = datos.tipoEspecie;
    const objetos = datos.objetos;
    const pdf = new jsPDF('p', 'pt', [600, 500]);
    const datosCabezaFamilia = grupoFamiliar.filter((miembro) => miembro.idpersona === cabezaFamilia.per_idpersona)[0];
    pdf.setFontSize(7).setFont("helvetica", 'normal');
    pdf.text("??", 10,20,);
    if(datos){
        const img = new Image()
        img.src = '/dist/img/alcaldialogo.jpg';
        let pageWidth = pdf.internal.pageSize.getWidth();
        let imgWidth = 70;
        let imgHeight = 40;
        let xPos = (pageWidth - imgWidth) / 2;
        pdf.addImage(img, 'png', xPos, 10, imgWidth, imgHeight);
        pdf.setFontSize(9).setFont("helvetica", 'bold');
        const text = "COMPONENTE DE RETORNO Y REUBICACION\nSCARACTERIZACION FAMILIAR Y VISITA\nDOMICILIARIA";
        const lines = pdf.splitTextToSize(text, 400);
        pdf.text(lines, 250, 60, { align: 'center' });
        pdf.setFontSize(8).setFont("helvetica", 'bold');
        const text2 = "OBJETIVO: Verificar la voluntariedad familiar respecto a la solicitud del retorno o la reubicación e\nindagar frente al plan de vida en el lugar de llegada.";
        const lines2 = pdf.splitTextToSize(text2, 500);
        pdf.text(lines2, 250, 95, { align: 'center' });
        pdf.setFontSize(8).setFont("helvetica", 'bold');
        pdf.text("NOMBRE COMPLETO:", 35, 120, { align: 'left' });
        pdf.setFontSize(8).setFont("helvetica", 'normal');
        pdf.text(`${datosCabezaFamilia.nombre1} ${datosCabezaFamilia.nombre2} ${datosCabezaFamilia.apellido1} ${datosCabezaFamilia.apellido2}`, 125, 120, { align: 'left' });
        const tableData = [
            ["CC", `${datosCabezaFamilia.idpersona || ''} de ${cabezaFamilia.municipio_cedula || ''}`],
            ["Dirección", `${ubicacion.cab_direccion || ''} Barrio ${ubicacion.bar_barrio || ''}`],
            ["Teléfonos/Fijos", `${ubicacion.cab_telefono1 || ''} ${ubicacion.cab_telefono2 || ''} Celular ${ubicacion.cab_celular || ''}`],
            ["Fecha Realización Entrevista", retorno.ret_fechaentrevista ? retorno.ret_fechaentrevista.substring(0, 10) : ''],
            ["Fecha Realización Visita Domiciliaria", retorno.ret_fechavisitadomiciliaria ? retorno.ret_fechavisitadomiciliaria.substring(0, 10) : ''],
            ["1. VALORACION SITUACION INICIAL ENCONTRADA", retorno.ret_valoracionsituacioninicial || '']
        ];

        autoTable(pdf, {
            startY: 130,
            startX: 10,
            body: tableData,
            styles: { fontSize: 7, cellPadding: 2 },
            bodyStyles: { valign: 'top' },
            columnStyles: {
            0: { cellWidth: 100 },
            1: { cellWidth: 300 },
            },
            tableWidth: 'wrap', // Ensures the table width is adjusted to its content
            margin: { left: (pdf.internal.pageSize.getWidth() - 400) / 2 }, // Centers the table horizontally
        });
        pdf.setFontSize(8).setFont("helvetica", 'bold');
        pdf.text("2. DATOS DEL DESPLAZAMIENTO:", 35, pdf.lastAutoTable.finalY + 10, { align: 'left' });

        const desplazamientoData = [
            ["Fecha", desplazamiento.fechadesplazamiento],
            ["Municipio Expulsor", desplazamiento.mun_municipio],
            ["No. de Personas", numeropersonasResult.total],
            ["Tiempo que lleva en la ciudad", retorno.ret_tiempociudad]
        ];

        autoTable(pdf, {
            startY: pdf.lastAutoTable.finalY + 20,
            body: desplazamientoData,
            styles: { fontSize: 7, cellPadding: 2 },
            bodyStyles: { valign: 'top' },
            columnStyles: {
            0: { cellWidth: 200 },
            1: { cellWidth: 200 },
            },
            tableWidth: 'wrap', // Ensures the table width is adjusted to its content
            margin: { left: (pdf.internal.pageSize.getWidth() - 400) / 2 }, // Centers the table horizontally
        });

        pdf.setFontSize(8).setFont("helvetica", 'bold');
        pdf.text("3. DATOS FAMILIARES DEL NUCLEO FAMILIAR SEGÚN DECLARACION", 35, pdf.lastAutoTable.finalY + 10, { align: 'left' });

        const grupoFamiliarData = grupoFamiliar.map((miembro) => [
            `${miembro.nombre1} ${miembro.nombre2 || ''} ${miembro.apellido1} ${miembro.apellido2 || ''}`.trim(),
            miembro.idpersona,
            miembro.parentesco,
            miembro.edad,
            miembro.oficio,
            miembro.ocupacion,
            miembro.asisteescuela,
            miembro.tipo_estudio,
        ]);

        autoTable(pdf, {
            startY: pdf.lastAutoTable.finalY + 20,
            head: [["Nombre Completo", "ID Persona", "Parentesco", "Edad", "Oficio", "Ocupación", "Asiste Escuela", "Tipo Estudio"]],
            body: grupoFamiliarData,
            styles: { fontSize: 7, cellPadding: 2 },
            bodyStyles: { valign: 'top' },
            columnStyles: {
            0: { cellWidth: 100 },
            1: { cellWidth: 50 },
            2: { cellWidth: 50 },
            3: { cellWidth: 30 },
            4: { cellWidth: 50 },
            5: { cellWidth: 50 },
            6: { cellWidth: 30 },
            7: { cellWidth: 40 },
            },
            tableWidth: 'wrap', // Ensures the table width is adjusted to its content
            margin: { left: (pdf.internal.pageSize.getWidth() - 400) / 2 }, // Centers the table horizontally
        });

        const desicionData = [
            ["3.1. Relacione los motivos planteados por el grupo familiar, para tomar la decisión de Retornar o Reubicarse.", motivosRetorno.map((motivo) => motivo.tip_tipomotivo).join(", ")],
            ["3.2. Razones por las cuales no se genero voluntariedad de algunos miembros del núcleo familiar, (Aplica para aquellas familiares donde la decisión no la asumen todos/as los miembros del núcleo familiar)", voluntariedadRetorno.map((motivo) => motivo.tipTipovoluntariedad).join(", ")],
        ];

        autoTable(pdf, {
            startY: pdf.lastAutoTable.finalY + 5,
            body: desicionData,
            styles: { fontSize: 7, cellPadding: 2 },
            bodyStyles: { valign: 'top' },
            columnStyles: {
            0: { cellWidth: 300 },
            1: { cellWidth: 100 },
            },
            tableWidth: 'wrap', // Ensures the table width is adjusted to its content
            margin: { left: (pdf.internal.pageSize.getWidth() - 400) / 2 }, // Centers the table horizontally
        });

        pdf.setFontSize(8).setFont("helvetica", 'bold');
        pdf.text("4. CONDICIONES ACTUALES PARA EL RETORNO O REUBICACION (FASE EXPLORATORIA)", 35, pdf.lastAutoTable.finalY + 10, { align: 'left' });
        
        const faseExploratoriaData = [
            ["4.1 Indique si su petición es para Retorno o Reubicación.", retorno.tip_tipoapoyo],
        ];

        autoTable(pdf, {
            startY: pdf.lastAutoTable.finalY + 20,
            body: faseExploratoriaData,
            styles: { fontSize: 7, cellPadding: 2 },
            bodyStyles: { valign: 'top' },
            columnStyles: {
            0: { cellWidth: 300 },
            1: { cellWidth: 100 },
            },
            tableWidth: 'wrap', // Ensures the table width is adjusted to its content
            margin: { left: (pdf.internal.pageSize.getWidth() - 400) / 2 }, // Centers the table horizontally
        });

        const condicionesData = [
            ["A. Departamento", retorno.dep_departamento, "B. Dirección", retorno.ret_direccionpeticion],
            ["C. Municipio", retorno.mun_municipio, "D. Teléfono", retorno.ret_telefonopeticion],
            ["E. Corregimiento", retorno.ret_corregimientopeticion, "F. Entorno", retorno.tipoentorno],
            ["G. Vereda o Barrio", retorno.ret_veredabarriopeticion, "H. Nombre de la Finca", retorno.ret_nombrefincapeticion],
        ];

        autoTable(pdf, {
            startY: pdf.lastAutoTable.finalY + 2,
            body: condicionesData,
            styles: { fontSize: 7, cellPadding: 2 },
            bodyStyles: { valign: 'top' },
            columnStyles: {
            0: { cellWidth: 100 },
            1: { cellWidth: 100 },
            2: { cellWidth: 100 },
            3: { cellWidth: 100 },
            },
            tableWidth: 'wrap', // Ensures the table width is adjusted to its content
            margin: { left: (pdf.internal.pageSize.getWidth() - 400) / 2 }, // Centers the table horizontally
        });
        const condicioneData = [
            ["I. Referencias del lugar de llegada", retorno.ret_referenciaspeticion],
        ];

        autoTable(pdf, {
            startY: pdf.lastAutoTable.finalY + 2,
            body: condicioneData,
            styles: { fontSize: 7, cellPadding: 2 },
            bodyStyles: { valign: 'top' },
            columnStyles: {
            0: { cellWidth: 100 },
            1: { cellWidth: 300 },
            },
            tableWidth: 'wrap', // Ensures the table width is adjusted to its content
            margin: { left: (pdf.internal.pageSize.getWidth() - 400) / 2 }, // Centers the table horizontally
        });

        pdf.addPage();

        pageWidth = pdf.internal.pageSize.getWidth();
        imgWidth = 70;
        imgHeight = 40;
        xPos = (pageWidth - imgWidth) / 2;
        pdf.addImage(img, 'png', xPos, 10, imgWidth, imgHeight);
        pdf.setFontSize(9).setFont("helvetica", 'bold');
        const text3 = "COMPONENTE DE RESTABLECIMIENTO\nSUBCOMPONENTE DE RETORNO Y REUBICACION CARACTERIZACION FAMILIAR Y VISITA\nDOMICILIARIA";
        const lines3 = pdf.splitTextToSize(text3, 400);
        pdf.text(lines3, 250, 60, { align: 'center' });
        
        const bienesData = [
            ["4.2. La vivienda en el lugar del retorno o la reubicación es de algún integrante de la familia incluida", retorno.ret_viviendaintegrante],
            ["4.2.1 Miembro de núcleo", retorno.propietarioviviendan],
            ["A. Tiene documentación de esa vivienda o tierras", retorno.ret_documentacionvivienda],
            ["B. Protegió el bien abandonado", retorno.ret_protegiobien],
            ["C. ¿Qué tipo de bien es?", retorno.tip_tipobien],
            ["D. Tiene Resolución de protección", retorno.ret_resolucionproteccion],
        ];

        autoTable(pdf, {
            startY: 100,
            body: bienesData,
            styles: { fontSize: 7, cellPadding: 2 },
            bodyStyles: { valign: 'top' },
            columnStyles: {
            0: { cellWidth: 300 },
            1: { cellWidth: 100 },
            },
            tableWidth: 'wrap', // Ensures the table width is adjusted to its content
            margin: { left: (pdf.internal.pageSize.getWidth() - 400) / 2 }, // Centers the table horizontally
        });

        pdf.setFontSize(8).setFont("helvetica", 'bold');
        pdf.text("4.3 Estado actual de la vivienda donde se retorna o se reubica :", 35, pdf.lastAutoTable.finalY + 10, { align: 'left' });

        const estadoPropiedadData = [
            ["TECHO", retorno.estadotecho, "PISOS", retorno.estadopisos],
            ["BAÑOS", retorno.estadobanos, "PAREDES", retorno.estadoparedes],
            ["COCINA", retorno.estadococina, "LA SOLUCION HABITACIONAL CUENTA CON SERVICIO DE ALCANTARILLADO", retorno.ret_servicioalcantarillado],
            ["LA SOLUCION HABITACIONAL CUENTA CON POZO SEPTICO", retorno.ret_serviciopozoseptico, "LA SOLUCION CUENTA CON SERVICIO DE ACUEDUCTO", retorno.ret_servicioacuaducto],
            ["LA SOLUCION CUENTA CON OTRA FUENTE DE ABASTECIMIENTO DE AGUA POTABLE, CUAL?", retorno.ret_otrafuenteagua, "LA SOLUCION HABITACIONAL CUENTA CON SERVICIO DE ENERGIA", retorno.ret_servicioenergia],
        ];

        autoTable(pdf, {
            startY: pdf.lastAutoTable.finalY + 20,
            body: estadoPropiedadData,
            styles: { fontSize: 7, cellPadding: 2 },
            bodyStyles: { valign: 'top' },
            columnStyles: {
            0: { cellWidth: 100 },
            1: { cellWidth: 100 },
            2: { cellWidth: 100 },
            3: { cellWidth: 100 },
            },
            tableWidth: 'wrap', // Ensures the table width is adjusted to its content
            margin: { left: (pdf.internal.pageSize.getWidth() - 400) / 2 }, // Centers the table horizontally
        });

        pdf.setFontSize(8).setFont("helvetica", 'bold');
        pdf.text("5. ESTADO ACTUAL DE ATENCIÓN EN SALUD", 35, pdf.lastAutoTable.finalY + 10, { align: 'left' });

        const saludData = [
            ["A. Afiliacion Salud EPSS (Subsidiado)", cabezaFamilia.saludcabeza, "", ""],
            ["B. ¿Los miembros del hogar requieren atención Psicosocial?", retorno.ret_miembrosatencionpsicosocial, "¿Quiénes?", miembrosAtencionPsicosocial.map((miembro) => `${miembro.nombre_completo}`.trim()).join(", ")],
            ["Educación", retorno.ret_educacion, "", ""],
            ["6. ¿Se ha postulado a las convocatorias de vivienda?", retorno.ret_convocatoriasvivienda, "¿Cúal?", retorno.convocatorias],
        ];

        autoTable(pdf, {
            startY: pdf.lastAutoTable.finalY + 20,
            body: saludData,
            styles: { fontSize: 7, cellPadding: 2 },
            bodyStyles: { valign: 'top' },
            columnStyles: {
            0: { cellWidth: 100 },
            1: { cellWidth: 100 },
            2: { cellWidth: 100 },
            3: { cellWidth: 100 },
            },
            tableWidth: 'wrap', // Ensures the table width is adjusted to its content
            margin: { left: (pdf.internal.pageSize.getWidth() - 400) / 2 }, // Centers the table horizontally
        });

        pdf.setFontSize(8).setFont("helvetica", 'bold');
        pdf.text("7. REDES FAMILIARES Y/O SOCIALES EN El LUGAR A RETORNAR O REUBICAR (ANALISIS SITUACIONAL)", 35, pdf.lastAutoTable.finalY + 10, { align: 'left' });
        
        const redesTableData = redesApoyo.map((red) => [
            red.tipored,
            red.ret_parentesco,
            red.ret_nombrecompleto,
            red.ret_telefonos,
            red.ret_direccion,
            red.mun_municipio,
        ]);

        autoTable(pdf, {
            startY: pdf.lastAutoTable.finalY + 20,
            head: [["Red", "Parentesco", "Nombre Completo", "Teléfonos", "Dirección", "Municipio"]],
            body: redesTableData,
            styles: { fontSize: 7, cellPadding: 2 },
            bodyStyles: { valign: 'top' },
            columnStyles: {
            0: { cellWidth: 80 },
            1: { cellWidth: 60 },
            2: { cellWidth: 80 },
            3: { cellWidth: 50 },
            4: { cellWidth: 70 },
            5: { cellWidth: 60 },
            },
            tableWidth: 'wrap', // Ensures the table width is adjusted to its content
            margin: { left: (pdf.internal.pageSize.getWidth() - 400) / 2 }, // Centers the table horizontally
        });
        
        const percepcionValoracionData = [
            ["Describir la percepción de la valoración que hace la familia de su red familiar y/o laboral", retorno.ret_descripcionvaloracionred],
        ];

        autoTable(pdf, {
            startY: pdf.lastAutoTable.finalY + 2,
            body: percepcionValoracionData,
            styles: { fontSize: 7, cellPadding: 2 },
            bodyStyles: { valign: 'top' },
            columnStyles: {
            0: { cellWidth: 150 },
            1: { cellWidth: 250 },
            },
            tableWidth: 'wrap', // Ensures the table width is adjusted to its content
            margin: { left: (pdf.internal.pageSize.getWidth() - 400) / 2 }, // Centers the table horizontally
        });

        
        // Add a new page
        pdf.addPage();
        
        pageWidth = pdf.internal.pageSize.getWidth();
        imgWidth = 70;
        imgHeight = 40;
        xPos = (pageWidth - imgWidth) / 2;
        pdf.addImage(img, 'png', xPos, 10, imgWidth, imgHeight);
        pdf.setFontSize(9).setFont("helvetica", 'bold');
        const text4 = "COMPONENTE DE RESTABLECIMIENTO\nSUBCOMPONENTE DE RETORNO Y REUBICACION CARACTERIZACION FAMILIAR Y VISITA\nDOMICILIARIA";
        const lines4 = pdf.splitTextToSize(text4, 400);
        pdf.text(lines4, 250, 60, { align: 'center' });

        pdf.setFontSize(8).setFont("helvetica", 'bold');
        pdf.text("8. VALORACIÓN Y ANALISIS SITUACIONAL DEL LUGAR DE LLEGADA", 35, 95, { align: 'left' });
        
        const analisisSituacionalData = [
            ["8.1 ¿Conoce el estado actual de seguridad en el lugar retorno o reubicación?", retorno.ret_estadoactualseguridad],
        ];

        autoTable(pdf, {
            startY: 100,
            body: analisisSituacionalData,
            styles: { fontSize: 7, cellPadding: 2 },
            bodyStyles: { valign: 'top' },
            columnStyles: {
            0: { cellWidth: 150 },
            1: { cellWidth: 250 },
            },
            tableWidth: 'wrap', // Ensures the table width is adjusted to its content
            margin: { left: (pdf.internal.pageSize.getWidth() - 400) / 2 }, // Centers the table horizontally
        });


        pdf.setFontSize(8).setFont("helvetica", 'bold');
        pdf.text("EL/LOS PROFESIONAL(ES) QUE DESARROLLAN LA VISITA DOMICILIARIA REITERAN CON EL\nNUCLEO FAMILIAR LAS SIGUIENTES PRECISIONES DE LA RUTA DE ACOMPAÑAMIENTO\nINTERINSTITUCIONAL:", 35, pdf.lastAutoTable.finalY + 20, { align: 'left' });

        pdf.setFontSize(7).setFont("helvetica", 'normal');
        pdf.text("La decisión de Retornar o Reubicación es Libre, Voluntaria y consenso con el núcleo familiar.", 35, pdf.lastAutoTable.finalY + 50, { align: 'left' });
        

        // Add space for sign and fingerprint
        pdf.setFontSize(8).setFont("helvetica", 'bold');
        const startY = pdf.lastAutoTable.finalY + 70;

        pdf.text("FIRMA DEL JEFE DE HOGAR:", 35, startY, { align: 'left' });
        pdf.line(35, startY + 20, 150, startY + 20); // Line for signature

        pdf.text("HUELLA", 360, startY, { align: 'left' });
        pdf.rect(300, startY + 5, 50, 50); // Box for fingerprint

        pdf.setFontSize(8).setFont("helvetica", 'bold');
        pdf.text("CÉDULA:", 35, startY + 30, { align: 'left' });

        // Add space for compañero's sign and fingerprint
        const companeroStartY = startY + 70;

        pdf.setFontSize(8).setFont("helvetica", 'bold');
        pdf.text("FIRMA DEL COMPAÑERO(A):", 35, companeroStartY, { align: 'left' });
        pdf.line(35, companeroStartY + 20, 150, companeroStartY + 20); // Line for signature

        pdf.text("HUELLA", 360, companeroStartY, { align: 'left' });
        pdf.rect(300, companeroStartY + 5, 50, 50); // Box for fingerprint

        pdf.setFontSize(8).setFont("helvetica", 'bold');
        pdf.text("CÉDULA:", 35, companeroStartY + 30, { align: 'left' });

        const observacionesFinales = [
            ["OBSERVACIONES FINALES", retorno.ret_observacionesfinales],
        ];

        autoTable(pdf, {
            startY: companeroStartY + 70,
            body: observacionesFinales,
            styles: { fontSize: 7, cellPadding: 2 },
            bodyStyles: { valign: 'top' },
            columnStyles: {
            0: { cellWidth: 150 },
            1: { cellWidth: 250 },
            },
            tableWidth: 'wrap', // Ensures the table width is adjusted to its content
            margin: { left: (pdf.internal.pageSize.getWidth() - 400) / 2 }, // Centers the table horizontally
        });

        pdf.setFontSize(8).setFont("helvetica", 'bold');
        const verificationText = "VERIFICACIÓN REDES SOCIALES Y FAMILIARES: Actividad que se desarrollará posterior a la visita domiciliaria con el objetivo de ampliar información social y familiar antes de la citación a actividad grupal familiar, actividad que será desarrollada por Profesional Psicosocial de la Gerencia.";
        const verificationLines = pdf.splitTextToSize(verificationText, 400);
        pdf.text(verificationLines, 35, pdf.lastAutoTable.finalY + 20, { align: 'left' });

        pdf.setFontSize(8).setFont("helvetica", 'normal');
        pdf.text(`Fecha: ${retorno.ret_fechavisitadomiciliaria.substring(0, 10)}`, 35, pdf.lastAutoTable.finalY + 50, { align: 'left' });  
        pdf.text(`Nombre del contacto: ${retorno.ret_redesnombrecontacto}`, 35, pdf.lastAutoTable.finalY + 60, { align: 'left' });  

        const resultadoData = [
            ["Resultado", retorno.ret_redesresultado]
        ];

        autoTable(pdf, {
            startY: pdf.lastAutoTable.finalY + 70,
            body: resultadoData,
            styles: { fontSize: 7, cellPadding: 2 },
            bodyStyles: { valign: 'top' },
            columnStyles: {
            0: { cellWidth: 100 },
            1: { cellWidth: 300 },
            },
            tableWidth: 'wrap', // Ensures the table width is adjusted to its content
            margin: { left: (pdf.internal.pageSize.getWidth() - 400) / 2 }, // Centers the table horizontally
        });

        pdf.setFontSize(8).setFont("helvetica", 'bold');
        pdf.text("Información posterior a la visita", 35, pdf.lastAutoTable.finalY + 20, { align: 'left' });

        const volutadData = [
            ["Voluntariedad:", retorno.ret_redesvoluntariedad, "Seguridad: Concepto de seguridad", retorno.redesconceptoseg],
            ["Entidad que emite el concepto:", retorno.ret_redesentidadconcepto, "", ""],
        ];

        autoTable(pdf, {
            startY: pdf.lastAutoTable.finalY + 30,
            body: volutadData,
            styles: { fontSize: 7, cellPadding: 2 },
            bodyStyles: { valign: 'top' },
            columnStyles: {
            0: { cellWidth: 100 },
            1: { cellWidth: 100 },
            2: { cellWidth: 100 },
            3: { cellWidth: 100 },
            },
            tableWidth: 'wrap', // Ensures the table width is adjusted to its content
            margin: { left: (pdf.internal.pageSize.getWidth() - 400) / 2 }, // Centers the table horizontally
        });

        pdf.addPage();
        pageWidth = pdf.internal.pageSize.getWidth();
        imgWidth = 70;
        imgHeight = 40;
        xPos = (pageWidth - imgWidth) / 2;
        pdf.addImage(img, 'png', xPos, 10, imgWidth, imgHeight);
        pdf.setFontSize(9).setFont("helvetica", 'bold');
        const text5 = "COMPONENTE DE RESTABLECIMIENTO\nSUBCOMPONENTE DE RETORNO Y REUBICACION CARACTERIZACION FAMILIAR Y VISITA\nDOMICILIARIAP";
        const lines5 = pdf.splitTextToSize(text5, 400);
        pdf.text(lines5, 250, 60, { align: 'center' });

        pdf.setFontSize(8).setFont("helvetica", 'bold');
        pdf.text("PSICOSOCIAL", 35, 95, { align: 'left' });
        const psicosocialData = [
            ["1. Se construyo plan de vida para el proceso de Retorno & Reubicación?:", retorno.ret_redesplanvida],
            ["Describir el proyecto de vida o plan de vida que tiene la familia o las personas que desean retornar o se reubicarsen:", retorno.ret_redesdescripcionplanvida],
        ];

        autoTable(pdf, {
            startY: 100,
            body: psicosocialData,
            styles: { fontSize: 7, cellPadding: 2 },
            bodyStyles: { valign: 'top' },
            columnStyles: {
            0: { cellWidth: 100 },
            1: { cellWidth: 300 },
            },
            tableWidth: 'wrap', // Ensures the table width is adjusted to its content
            margin: { left: (pdf.internal.pageSize.getWidth() - 400) / 2 }, // Centers the table horizontally
        });

        pdf.setFontSize(8).setFont("helvetica", 'bold');
        pdf.text("3. Componente seguridad alimentaria", 35, pdf.lastAutoTable.finalY + 2, { align: 'left' });
        
        const tipoExplotacionData = [
            ["1. Se construyo plan de vida para el proceso de Retorno & Reubicación?:", tipoexplotacion.map((tipo) => tipo.ret_tipoexplotacion).join(", ")],  
            ["ESPECIES QUE LE GUSTARIA TRABAJAR EN SU PREDIO:", tipoEspecie.map((tipo) => tipo.ret_tipoespecie).join(", ")],
        ];

        autoTable(pdf, {
            startY: pdf.lastAutoTable.finalY + 10,
            body: tipoExplotacionData,
            styles: { fontSize: 7, cellPadding: 2 },
            bodyStyles: { valign: 'top' },
            columnStyles: {
            0: { cellWidth: 100 },
            1: { cellWidth: 300 },
            },
            tableWidth: 'wrap', // Ensures the table width is adjusted to its content
            margin: { left: (pdf.internal.pageSize.getWidth() - 400) / 2 }, // Centers the table horizontally
        });
        const insumosData = [
            ["Describir los insumos o materiales que requiere el acampamiento con el plan productivo diferencial", retorno.ret_redesdescripcioninsumos],
            ["Describir el proyecto de vida o plan de vida que tiene la familia o las personas que desean retornar o se reubicarsen:", retorno.ret_redesdescripcionplanvida],
        ];

        autoTable(pdf, {
            startY: pdf.lastAutoTable.finalY + 30,
            body: insumosData,
            styles: { fontSize: 7, cellPadding: 2 },
            bodyStyles: { valign: 'top' },
            columnStyles: {
            0: { cellWidth: 100 },
            1: { cellWidth: 300 },
            },
            tableWidth: 'wrap', // Ensures the table width is adjusted to its content
            margin: { left: (pdf.internal.pageSize.getWidth() - 400) / 2 }, // Centers the table horizontally
        });

        pdf.setFontSize(8).setFont("helvetica", 'bold');
        pdf.text("Valores aproximados a entregar", 35, pdf.lastAutoTable.finalY + 2, { align: 'left' });

        const valoresData = [
            ["Transporte de Personas No de personas", retorno.ret_redestransportepersonasnro, "Costos aproximados", retorno.ret_redestransportepersonascosto],
            ["Acarreo de Enseres: Costos aproximados", retorno.ret_redesacarreocosto, "", ""],
        ];

        autoTable(pdf, {
            startY: pdf.lastAutoTable.finalY + 5,
            body: valoresData,
            styles: { fontSize: 7, cellPadding: 2 },
            bodyStyles: { valign: 'top' },
            columnStyles: {
            0: { cellWidth: 100 },
            1: { cellWidth: 100 },
            2: { cellWidth: 100 },
            3: { cellWidth: 100 },
            },
            tableWidth: 'wrap', // Ensures the table width is adjusted to its content
            margin: { left: (pdf.internal.pageSize.getWidth() - 400) / 2 }, // Centers the table horizontally
        });

        pdf.setFontSize(8).setFont("helvetica", 'bold');
        pdf.text("Describir objetos por llevar", 35, pdf.lastAutoTable.finalY + 5, { align: 'left' });

        const objetosData = objetos.map((objeto) => [
            objeto.tipo_objeto,
            objeto.ret_cantidad,
        ]);

        autoTable(pdf, {
            startY: pdf.lastAutoTable.finalY + 20,
            head: [["tipo_objeto", "ret_cantidad"]],
            body: objetosData,
            styles: { fontSize: 7, cellPadding: 2 },
            bodyStyles: { valign: 'top' },
            columnStyles: {
                0: { cellWidth: 150 },
                1: { cellWidth: 50 },
            },
            tableWidth: 'wrap', // Ensures the table width is adjusted to its content
            margin: { left: (pdf.internal.pageSize.getWidth() - 400) / 2 }, // Centers the table horizontally
        });
    }
    const pdfBlob  = pdf.output('blob');
    const fileURL = URL.createObjectURL(pdfBlob); 
    return fileURL;
};

export default ConstruirPdfFormatoRetorno;
